import axios from "axios";
import { API } from "./constants";

// Use this for all admin/protected endpoints. It sends the httpOnly session cookie.
// Public endpoints should keep using the default axios (no credentials) so they
// don't trigger the browser's credentialed-CORS check on `Access-Control-Allow-Origin: *`.
export const adminAxios = axios.create({
  baseURL: API,
  withCredentials: true,
});
